<script lang="ts">
    import type {MessageContact} from "./Types";
    export let entity: MessageContact
</script>
<div class="alert alert-info m-0">
    Повідомлення з передачею контакта
    <table class="table table-bordered table-sm">
        <tr>
            <td>Ім'я</td>
            <td>{entity.contact.first_name}</td>
        </tr>
        <tr>
            <td>Призвище</td>
            <td>{entity.contact.last_name}</td>
        </tr>
        <tr>
            <td>Телефон</td>
            <td>{entity.contact.phone_number}</td>
        </tr>
        <tr>
            <td>Telegram User ID</td>
            <td>{entity.contact.user_id}</td>
        </tr>
    </table>
</div>
